import Api from '@/common/fetch.js'
import { apiRoute } from '@/common/config'

export default {
    login (request) {
        return Api.post(apiRoute + '/Login', request)
    },
    logout (request) {
        return Api.post(apiRoute + '/Logout', request)
    },
    getUser () {
        return Api.get(apiRoute + '/GetSessionInfo')
    },
    generateTempPassword (request) {
        return Api.post(apiRoute + '/generateTempPassword', request)
    },
    changePasswordNoChecking (request) {
        return Api.post(apiRoute + '/changePasswordNoChecking', request)
    },
}
